export const SCHEDULE = {
    MONTHLY: 'M',
    QUARTERLY: 'Q',
    YEARLY: 'Y'
};